/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builder_Block_Price_BadgeInputs */

const cs_builder_block_price_badge = /** @type {(inputs: Builder_Block_Price_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cenový odznak`)
};

const en_builder_block_price_badge = /** @type {(inputs: Builder_Block_Price_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Price badge`)
};

/**
* | output |
* | --- |
* | "Price badge" |
*
* @param {Builder_Block_Price_BadgeInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const builder_block_price_badge = /** @type {((inputs?: Builder_Block_Price_BadgeInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builder_Block_Price_BadgeInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_builder_block_price_badge(inputs)
	return cs_builder_block_price_badge(inputs)
});